import login from './login';

export default {
  language: 'uz',
  country: 'uz',
  name: "O'zbek",
  embeddedLocale: login,
  flags: ['UZ'],
};
